import { render, staticRenderFns } from "./HeaderWishlist.vue?vue&type=template&id=d021cc9a&"
import script from "./HeaderWishlist.vue?vue&type=script&lang=ts&"
export * from "./HeaderWishlist.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports